import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M20,2H5A3,3,0,0,0,2,5V17a3,3,0,0,0,3,3H7v6a1,1,0,0,0,.61.92A1.09,1.09,0,0,0,8,27a1,1,0,0,0,.7-.29L15.41,20H20a3,3,0,0,0,3-3V5A3,3,0,0,0,20,2ZM12.27,15.08a.89.89,0,1,1,.92-.89A.89.89,0,0,1,12.27,15.08ZM14,10.93c-.71.41-.93.65-1,1.12h0a.67.67,0,0,1-.75.57.67.67,0,0,1-.76-.67V11.9a1.69,1.69,0,0,1,1-1.57c.72-.42.94-.69.94-1.2a.94.94,0,0,0-1.06-.88,1.09,1.09,0,0,0-1.11.83.69.69,0,0,1-.72.47.62.62,0,0,1-.7-.67A1.58,1.58,0,0,1,9.9,8.5a2.54,2.54,0,0,1,2.58-1.56c1.6,0,2.67.88,2.67,2.14A2,2,0,0,1,14,10.93Z"/><path d="M27,5H26a1,1,0,0,0,0,2h1a1,1,0,0,1,1,1V19.57A1.43,1.43,0,0,1,26.57,21H25a1.81,1.81,0,0,0-.4,0l-.17.05-.2.06-.24.13-.09,0a2.15,2.15,0,0,0-.28.23h0a2.17,2.17,0,0,0-.24.29,2.35,2.35,0,0,0-.22.45.56.56,0,0,0,0,.12A1.83,1.83,0,0,0,23,23h0s0,0,0,0h0v3.59h0l-.73-.72-3.5-3.5h0a1,1,0,0,0-1.41,1.42l5.93,5.94a1,1,0,0,0,.33.21.94.94,0,0,0,.76,0,1,1,0,0,0,.54-.54A1,1,0,0,0,25,29V23h2a3,3,0,0,0,3-3V8A3,3,0,0,0,27,5Z"/>';
export var AskQuestionSVG = function AskQuestionSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
AskQuestionSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(AskQuestionSVG);